// /src/index.jsx

import { createRoot } from 'react-dom/client';
import Modal from 'react-modal';
import './axiosInterceptors';
import './i18n';
import './wsRecovery';
import AppWrapper from './AppWrapper';
import AntDesignIconsCspProvider from './components/AntDesignIconsCspProvider';
import { CacheProvider } from '@emotion/react';
import createEmotionCache from '../utils/emotionCache';
import { AuthProvider } from './authContext';
import { SecurityProvider } from "./SecurityContext";
import TextSelectionBypass from "./components/TextSelectionBypass";
import { NotificationsProvider } from './notificationsProvider';
import RootErrorBoundary from "./RootErrorBoundary";
import 'bootstrap';
import './styles/styles.scss';
import { bootstrapAuth } from "./bootstrapAuth";
import { ensureDeviceId } from "../utils/deviceId";
import { clearBlockLoginAutoRedirect } from "./authSessionStorage";
import { initGlobalNetworkLogs } from "../utils/globalNetworkEvents";
import { preloadUser } from "./preloadUser";
import { StatusProvider } from "./StatusContext";
import { VersionProvider } from "./VersionContext";
import { initChunkLoadRecovery } from "../utils/chunkLoadRecovery";
import { ensureFreshFrontendBundle } from "../utils/ensureFreshFrontendBundle";

initChunkLoadRecovery();


const _removeChild = Node.prototype.removeChild;
Node.prototype.removeChild = function (child) {
  try {
    if (child && !this.contains(child)) {
      console.groupCollapsed(
        "[DOM ERROR] removeChild called on a node that does not contain its target:"
      );
      console.log("Parent:", this);
      console.log("Child:", child);
      console.trace("Call stack:");
      console.groupEnd();
      return child;
    }
  } catch (e) {
    console.error("Error during removeChild hook:", e);
  }
  return _removeChild.call(this, child);
};

const emotionCache = createEmotionCache();
initGlobalNetworkLogs();

async function init() {
  ensureDeviceId();

  await ensureFreshFrontendBundle();

  const { user: rawUser, permissions: preloadedPermissions } = await bootstrapAuth();
  if (rawUser?.isLoggedIn) {
    clearBlockLoginAutoRedirect();
  }
  const preloadedUser = await preloadUser(rawUser);

  const root = createRoot(document.getElementById('root'));
  root.render(
    <RootErrorBoundary>
      <CacheProvider value={emotionCache}>
        <AntDesignIconsCspProvider>
          <StatusProvider>
            <AuthProvider preloadedUser={preloadedUser}>
              <VersionProvider>
                <SecurityProvider preloadedPermissions={preloadedPermissions}>
                  <TextSelectionBypass />
                  <NotificationsProvider>
                    <AppWrapper />
                  </NotificationsProvider>
                </SecurityProvider>
              </VersionProvider>
            </AuthProvider>
          </StatusProvider>
        </AntDesignIconsCspProvider>
      </CacheProvider>
    </RootErrorBoundary>
  );
}

init(); // ✅ on démarre après le bootstrap
